import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Problema from '../../../../assets/images/custo.png';
import Foto1 from '../../../../assets/images/roi.jpg';

import * as AiIcons from "react-icons/ai";
import * as BiIcons from "react-icons/bi";
import * as FcIcons from "react-icons/fc";
import * as MdIcons from "react-icons/md";

import AltoCusto from './AltoCusto/AltoCusto';
import Alternativa from './Alternativa/Alternativa';
import BaixoCusto from './BaixoCusto/BaixoCusto';

import 'bootstrap/dist/css/bootstrap.min.css';


function Custo() {
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Popover Information</Popover.Header>
      <Popover.Body>
        Here is some <strong>interesting</strong> information about connected devices and their impact on Wi-Fi networks.
      </Popover.Body>
    </Popover>
  );

  const PopoverButton = () => (
    <OverlayTrigger trigger="click" placement="right" overlay={popover}>
      <Button variant="outline-primary" style={{ padding: '0 5px', margin: '0 5px', fontSize: 'inherit' }}>dispositivos conectados </Button>
    </OverlayTrigger>
  );

  const [activeTab, setActiveTab] = useState('/altocusto');

  const handleTabSelect = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <h1>Custo da tecnologia</h1>
            <img src={Problema} alt='problema' className='img-fluid mb-2' />

            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
              <Nav fill variant="tabs" defaultActiveKey="/altocusto">
                <Nav.Item>
                  <Nav.Link eventKey="/altocusto">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Exelentes roteadores</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="/alternativa">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Roteadores medianos</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="/baixocusto">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Roteadores de baixo custo</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content className='container'>
                    <Tab.Pane eventKey="/altocusto">
                        <AltoCusto />
                    </Tab.Pane>                     
                    <Tab.Pane eventKey="/alternativa">
                        <Alternativa />
                    </Tab.Pane> 
                    <Tab.Pane eventKey="/baixocusto">
                        <BaixoCusto />
                    </Tab.Pane>                     
                </Tab.Content>
            </Tab.Container>
          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='imagem'>
              <img className="d-block w-100" src={Foto1} alt="First slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Custo;
